import { fundingHqFetch } from './fundingApi';

function agencyQuery(agencyId) {
  const params = new URLSearchParams({ agency_id: agencyId });
  return params.toString();
}

export async function createFundingSubmission(clientId, agencyId, payload) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/submissions?${agencyQuery(agencyId)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function createSubmissionFromMatch(matchId, agencyId) {
  return fundingHqFetch(`/matches/${encodeURIComponent(matchId)}/submission`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ agency_id: agencyId }),
  });
}

export async function createSubmissionFromSequenceItem(sequenceId, itemId, agencyId) {
  return fundingHqFetch(
    `/sequences/${encodeURIComponent(sequenceId)}/items/${encodeURIComponent(itemId)}/submission`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ agency_id: agencyId }),
    },
  );
}

export async function fetchFundingSubmissions({ agencyId, clientId, status, lenderType, productType, search, limit = 100 } = {}) {
  const params = new URLSearchParams();
  if (agencyId) params.set('agency_id', agencyId);
  if (clientId) params.set('client_id', clientId);
  if (status) params.set('status', status);
  if (lenderType) params.set('type', lenderType);
  if (productType) params.set('product_type', productType);
  if (search) params.set('search', search);
  if (limit) params.set('limit', String(limit));
  const query = params.toString();
  const data = await fundingHqFetch(`/submissions${query ? `?${query}` : ''}`);
  return {
    submissions: data.submissions ?? [],
    total: data.total ?? (data.submissions?.length ?? 0),
  };
}

export async function fetchClientFundingSubmissions(clientId, agencyId) {
  const data = await fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/submissions?${agencyQuery(agencyId)}`,
  );
  return {
    submissions: data.submissions ?? [],
    total: data.total ?? (data.submissions?.length ?? 0),
  };
}

export async function fetchFundingSubmission(submissionId, agencyId) {
  return fundingHqFetch(
    `/submissions/${encodeURIComponent(submissionId)}?${agencyQuery(agencyId)}`,
  );
}

export async function updateFundingSubmission(submissionId, agencyId, payload) {
  return fundingHqFetch(
    `/submissions/${encodeURIComponent(submissionId)}?${agencyQuery(agencyId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function deleteFundingSubmission(submissionId, agencyId) {
  return fundingHqFetch(
    `/submissions/${encodeURIComponent(submissionId)}?${agencyQuery(agencyId)}`,
    { method: 'DELETE' },
  );
}

export function emptyFundingSubmissionForm() {
  return {
    lender_id: '',
    lender_name: '',
    lender_type: '',
    product_type: '',
    requested_amount: '',
    submission_method: 'Manual',
    notes: '',
  };
}
